import { ConfirmOrder } from '../../../components/OrderClose/ConfirmOrder'
import { EmptyCart } from '../../../components/EmptyCart'
import { currency } from '../../../helpers/currency_fomat'
import { useCart } from '../../../hooks/useCart'
import * as Styled from './styles'

import { FaTrashAlt } from 'react-icons/fa'

export const Table = () => {
  const { cart, snackCartDecrement, snackCartIncrement, removeSnackCart } = useCart()
  return (
    <Styled.Container>
      {cart.length === 0 ? (
        <EmptyCart title='Ops! Não há pedidos, peça já!' />
      ) : (
        <>
          <Styled.HeadTable>
            <span>Lanche</span>
            <span>Qtd</span>
            <span>Sutotal</span>
            <span></span>
          </Styled.HeadTable>

          {cart.map((item) => (
            <Styled.Table key={item.name}>
              <span>
                <img src={item.image} alt={item.name} />
                <span>
                  <h4>{item.name}</h4>
                  <div className='price' style={{ fontSize: '1.5rem' }}>
                    {currency(item.price)}
                  </div>
                </span>
              </span>
              <span>
                <button onClick={() => snackCartDecrement(item)} style={{ fontSize: '1.5rem' }}>
                  -
                </button>
                <div>{`${item.quantity}`.padStart(2, '0')}</div>
                <button onClick={() => snackCartIncrement(item)}>+</button>
              </span>
              <span>
                <div>{currency(item.subtotal)}</div>
              </span>
              <span>
                <button onClick={() => removeSnackCart(item)}>
                  <FaTrashAlt />
                </button>
              </span>
            </Styled.Table>
          ))}
          <ConfirmOrder />
        </>
      )}
    </Styled.Container>
  )
}
